import {BsChevronDown} from "react-icons/bs";
import classNames from "classnames";
import { useState } from "react";

const Accordion = (props)=>{
    const [active, setActive] = useState(false);

    return <div className={classNames('dycDetalleDescription', { 'dycDetalleDescription-show': (props.isopen || active), 'marginBottom': props.margin })}>
        <div className="dycDetalleDescriptionTitle" onClick={ ()=>{ setActive((!active)) } }>
            {props.title}
            <BsChevronDown/>
        </div>
        <div className="dycDetalleDescriptionContent">
            {props.children}
        </div>
    </div>
};

export default Accordion;